/* Local dependencies */
import { GetDevicesActions, GetServiceActionTypes } from './action';

const initialState = {
  isLoading: true,
  isLoadingComplete: false,
};

export interface GetDevicesState {
  loading: boolean;
  error: null | Error;
}

export const initialGetDevicesState: GetDevicesState = {
  loading: false,
  error: null,
};

export default function getDevices(state = initialGetDevicesState, action: GetDevicesActions) {
  switch (action.type) {
    default:
      return state;
  }
}
